import React from 'react';
import { FaPlus, FaSearch } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import Sidebar from './Sidemenu';

const Campaign = () => {
  const navigate = useNavigate();

  const handleNewButtonClick = () => {
    navigate('/newcampaign');
  };
  
 
  return (
    <div style={{ display: 'flex' }}>
    
    <Sidebar />
    <div className="segment-container" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
  <div className="header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '50px' }}>
    <h1 style={{ marginLeft:'5%' }}>Campaigns</h1>
    <button
    className="btn btn-primary"
    style={{ marginLeft:'290%',width:'70px' }}
    onClick={handleNewButtonClick}
  >
    <span>New</span>
  </button>
  

  
</div>

      <div className="filter-bar">
        <div className="input-group search-box" style={{ width:'150%',marginLeft:'15%' }}>
          <span className="input-group-text" id="basic-addon1"><FaSearch /></span>
          <input type="text" className="form-control" placeholder="Filter.." aria-label="Filter" aria-describedby="basic-addon1" />
        </div>
      </div>
      </div>

    </div>
  );
};

export default Campaign;
